/* eslint-disable @typescript-eslint/no-unused-vars */
import { postAuth, getAuth } from "@/core/config/ApiService";

class Account {
  async accountLists(data: any): Promise<any> {
    const resp = await getAuth("api/crm/bank-accounts", data);
    return resp.data;
  }

  async addAccount(data: any): Promise<any> {
    const resp = await postAuth("api/crm/bank-account", data);
    return resp.data;
  }

  async ChangePassword(data: any): Promise<any> {
    const resp = await postAuth("api/crm/update-password", data);
    return resp.data;
  }

  async PayWithProvider(data: any): Promise<any> {
    const resp = await postAuth("/api/crm/pay-with-provider", data);
    return resp.data;
  }

  async depositProviders(): Promise<any> {
    const resp = await getAuth("api/crm/deposit-providers");
    return resp.data;
  }

  async deleteBankAccount(data: any): Promise<any> {
    const resp = await postAuth("/api/crm/delete-bank-account", data);
    return resp.data;
  }

  async searchBankAccounts(query: string): Promise<any> {
    const resp = await getAuth("api/crm/bank-accounts/search", { query });
    return resp.data;
  }
}
export default new Account();
